// TODO: Fix janky transition on popover open
// (This component was copied from Sidebar/PremiumBadge, which already had that bug)

import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { pageLang, t } from 'js/intl/t';
import 'js/i18n/page_translations/work_page_modals/en.wjs';

const PREMIUM_ACADEMICS = 270000;
const PREMIUM_UNIVERSITIES = 16000;

// The page lang's separators (270.000, 270 000), not baked into each translation.
const formatCount = (n: number): string =>
  new Intl.NumberFormat(pageLang()).format(n);

const PremiumBadgeIcon = styled.div`
  position: relative;
  top: -2px;
`;

// The container, on load, has its leftmost edge aligned with the leftmost edge of the icon.
// In order for it to be centered about the center the icon, it must be translated:
// * left (-50%), so its center is aligned with the leftmost edge of the icon;
// * right (+9px), which is half the width of the icon (18px)
const CENTER_CONTAINER_TO_ICON = `-50% + 9px`;

const Container = styled.div`
  width: 343px;
  padding: var(--spacing-xs-16, 16px);

  position: absolute;
  top: 36px;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-xs-16, 16px);
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid #0754d3;
  background: #0754d3;
  box-shadow: 0px 6px 16px 0px rgba(7, 10, 21, 0.25);

  // translate -50% plus half of icon width (18px)
  transform: translate(calc(${CENTER_CONTAINER_TO_ICON}));

  // give user a larger hover area
  &:before {
    content: '';
    position: absolute;
    top: -36px;
    left: 50%;
    transform: translate(-50%);
    width: 36px;
    height: 50%;
  }
`;

const Triangle = styled.div`
  position: absolute;

  width: 0px;
  height: 0px;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #0954d3;
  top: -14px;
  left: 50%;
  transform: translate(-50%);
`;

const PopoverIconLaurel = styled.img`
  height: 42px;
`;

const PopoverInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xs-8, 8px);
`;

const PopoverText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  /* or 136% */
  letter-spacing: 0.02em;

  color: #ffffff;
`;

const PopoverCTA = styled.button`
  @import 'stylesheets/design_system/font';
  @include body__extra-small;

  display: flex;
  align-items: center;
  height: 18px;
  padding: 0px var(--spacing-xs-8, 8px);
  gap: var(--buttons-small-buttons-gap, 8px);

  border-radius: var(--border-radius-radius-lg);
  background: var(--button-secondary-fill, #eef2f9);
  color: #0754d3;
`;

const PremiumBadge = () => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <PremiumBadgeIcon
      onMouseOver={() => setShowPopover(true)}
      onMouseLeave={() => setShowPopover(false)}
    >
      <img src={$image_url('premium/Badge-Laurel.svg')} />
      {showPopover && <PremiumBadgePopover />}
    </PremiumBadgeIcon>
  );
};

const PremiumBadgePopover = () => {
  const parentContainer = useRef(null);
  const triangle = useRef(null);
  useLayoutEffect(() => {
    // type never?
    const containerDOM = parentContainer?.current;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const containerDOMRect = containerDOM?.getBoundingClientRect();
    const containerRightEdge = containerDOMRect.right;
    const viewportWidth = window.innerWidth;
    const MINIMUM_RIGHT_PADDING = 10;
    if (containerRightEdge > viewportWidth - MINIMUM_RIGHT_PADDING) {
      //  adjustedEdge
      //       |
      //      viewport    rightEdge
      //       | |           |
      //       x x           x
      //
      // distance btwn rightEdge and adjustedEdge is minPadding + (rightEdge - viewport)
      const distance =
        MINIMUM_RIGHT_PADDING + containerRightEdge - viewportWidth;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      containerDOM.style.transform = `translateX(calc(${CENTER_CONTAINER_TO_ICON} - ${distance}px))`;

      // adjust the triangle
      const triangleDOM = triangle?.current;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      triangleDOM.style.transform = `translateX(calc(-50% + ${distance}px))`;
    }
  });

  return (
    <Container
      ref={parentContainer}
      style={{ animation: '180ms fade-in ease-in' }}
    >
      <Triangle ref={triangle} />
      <PopoverIconLaurel src={$image_url('premium/Badge-Laurel.svg')} />
      <PopoverInfo>
        <PopoverText>
          {t('work_page_modals.premium_badge.popover_text', {
            academic_count: formatCount(PREMIUM_ACADEMICS),
            university_count: formatCount(PREMIUM_UNIVERSITIES),
          })}
        </PopoverText>
        <PopoverCTA
          as="a"
          href={routes.upgrade_url({
            feature: 'default',
            trigger: 'author-badge',
          })}
        >
          {t('work_page_modals.premium_badge.learn_more')}
        </PopoverCTA>
      </PopoverInfo>
    </Container>
  );
};

export default PremiumBadge;
